
class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.addEventListener("keyup", this.onKeyUp.bind(this));
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
        this.querySelectorAll("button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;
        const openDetailsElement = event.target.closest("details[open]");
        if (!openDetailsElement) return;
        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(openDetailsElement);
    }
    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest(".has-submenu");
        const isOpen = detailsElement.hasAttribute("open");
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
            summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
        }
        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
            if (window.matchMedia("(max-width: 990px)")) {
                document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add("menu-opening");
                summaryElement.setAttribute("aria-expanded", !0);
                parentMenuElement && parentMenuElement.classList.add("submenu-open");
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
            }, 100);
        }
    }
    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        });
        summaryElement.setAttribute("aria-expanded", !0);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus = !1) {
        if (event === undefined) return;
        this.mainDetailsToggle.classList.remove("menu-opening");
        this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
            details.removeAttribute("open");
            details.classList.remove("menu-opening");
        });
        this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
            submenu.classList.remove("submenu-open");
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
        if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", !1);
    }
    onFocusOut() {
        setTimeout(() => {
            if (this.mainDetailsToggle && this.mainDetailsToggle?.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest("details");
        this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
        if (!detailsElement) return;
        const parentMenuElement = detailsElement?.closest(".submenu-open");
        parentMenuElement && parentMenuElement.classList.remove("submenu-open");
        detailsElement.classList.remove("menu-opening");
        detailsElement.querySelector("summary").setAttribute("aria-expanded", !1);
        removeTrapFocus(detailsElement.querySelector("summary"));
        this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
        let animationStart;
        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }
            const elapsedTime = time - animationStart;
            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
                }
            }
        };
        window.requestAnimationFrame(handleAnimation);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(summaryElement) {
        this.header = this.header || document.querySelector(".section-header");
        this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
        document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add("menu-open");
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        });
        summaryElement.setAttribute("aria-expanded", !0);
        window.addEventListener("resize", this.onResize);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(event, elementToFocus) {
        if (!elementToFocus) return;
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove("menu-open");
        window.removeEventListener("resize", this.onResize);
    }
    onResize = () => {
        this.header && document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
    };
}
customElements.define("header-drawer", HeaderDrawer);

const buttons = document.querySelectorAll(".custom-summary");
buttons.forEach((button) => {
    button.addEventListener("click", () => {
        var isExpanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", !isExpanded);
        if (!isExpanded) {
            button.setAttribute("open", "");
            document.body.classList.add("keep-green");
        } else {
            button.removeAttribute("open");
            document.body.classList.remove("keep-green");
        }
    });
});
const subMenuItems = document.querySelectorAll(".menu-drawer__menu-item[data-entity-title]");
const menuImageContainer = document.querySelector("[data-menu-image]");
const menuTitle = menuImageContainer?.querySelector(".menu-title > span");
const menuSubtitle = menuImageContainer?.querySelector(".menu-subtitle > span");
const menuImage = menuImageContainer?.querySelectorAll(".menu-image");
const menuTitleBis = menuImageContainer?.querySelector(".menu-title span + span");
const menuSubtitleBis = menuImageContainer?.querySelector(".menu-subtitle span + span");
function isValid(value) {
    return value !== null && value !== "" && value !== "null";
}
subMenuItems.forEach((item) => {
    const collectionId = item.getAttribute("data-entity-id");
    const collectionTitle = item.getAttribute("data-entity-title");
    const collectionSubtitle = item.getAttribute("data-entity-subtitle");
    const collectionImage = item.getAttribute("data-entity-image");
    if (!isValid(collectionId) || !isValid(collectionTitle)) return;
    item.addEventListener("mouseenter", () => {
        const titleSpan = document.getElementById(`menu-title-${collectionId}`);
        const subtitleSpan = document.getElementById(`menu-subtitle-${collectionId}`);
        const imageEl = document.getElementById(`menu-image-${collectionId}`);
        if (!titleSpan) {
            menuTitle?.insertAdjacentHTML("afterend", `<span id="menu-title-${collectionId}" class="tw-transition-opacity tw-size-full tw-duration-500 tw-opacity-0 tw-absolute tw-top-0 tw-left-0 tw-text-center">${collectionTitle}</span>`);
        }
        if (isValid(collectionSubtitle) && !subtitleSpan) {
            menuSubtitle?.insertAdjacentHTML(
                "afterend",
                `<span id="menu-subtitle-${collectionId}" class="tw-transition-opacity tw-size-full tw-duration-500 tw-text-center tw-opacity-0 tw-absolute tw-top-0 tw-left-0">${collectionSubtitle}</span>`
            );
        }
        if (isValid(collectionImage) && !imageEl) {
            menuImage[0]?.insertAdjacentHTML(
                "afterend",
                `<img loading="lazy" id="menu-image-${collectionId}" height="600" width="800" src="${collectionImage}" alt="Menu Image Hover" class="menu-image tw-z-[-2] tw-absolute tw-top-0 tw-left-0 tw-size-full tw-brightness-75 tw-object-cover tw-transition-opacity tw-duration-500 tw-opacity-0" />`
            );
        }
        setTimeout(() => {
            const data_image_menu = document.querySelector("[data-menu-image] > div");
            data_image_menu?.classList.add("-tw-translate-y-14");
            const tempImg = document.getElementById(`menu-image-${collectionId}`);
            const tempTitle = document.getElementById(`menu-title-${collectionId}`);
            const tempSubtitle = document.getElementById(`menu-subtitle-${collectionId}`);
            [tempImg, tempTitle, tempSubtitle].forEach((el) => el?.classList.remove("tw-opacity-0"));
            [menuTitle, menuSubtitle].forEach((el) => el?.classList.add("tw-opacity-0"));
        }, 10);
    });
    item.addEventListener("mouseleave", () => {
        const tempImg = document.getElementById(`menu-image-${collectionId}`);
        const tempTitle = document.getElementById(`menu-title-${collectionId}`);
        const tempSubtitle = document.getElementById(`menu-subtitle-${collectionId}`);
        const data_menu_image = document.querySelector("[data-menu-image] > div");
        data_menu_image?.classList.remove("-tw-translate-y-14");
        [tempImg, tempTitle, tempSubtitle].forEach((el) => el?.classList.add("tw-opacity-0"));
        setTimeout(() => {
            [tempImg, tempTitle, tempSubtitle].forEach((el) => el?.remove());
        }, 500);
        [menuTitle, menuSubtitle].forEach((el) => el?.classList.remove("tw-opacity-0"));
    });
});
const submenuToggles = document.querySelectorAll(".submenu-toggle");
submenuToggles.forEach((toggle) => {
    const contentId = toggle.getAttribute("aria-controls");
    const content = document.getElementById(contentId);
    if (!content) return;
    toggle.addEventListener("click", () => {
        const isExpanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isExpanded));
    });
    const submenuItems = content.querySelectorAll(".menu-drawer__menu-item");
    submenuItems.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            const siblings = Array.from(content.querySelectorAll(".menu-drawer__menu-item")).filter((sib) => sib !== item);
            siblings.forEach((sibling) => {
                const span = sibling.querySelector("span");
                if (span) span.style.opacity = "0.5";
                sibling.style.pointerEvents = "none";
            });
        });
        item.addEventListener("mouseleave", () => {
            const siblings = Array.from(content.querySelectorAll(".menu-drawer__menu-item")).filter((sib) => sib !== item);
            siblings.forEach((sibling) => {
                const span = sibling.querySelector("span");
                if (span) span.style.opacity = "1";
                sibling.style.pointerEvents = "auto";
            });
        });
    });
});
